<template>
<ButtonPrimary v-on="$listeners" class="v-btn--assignment ButtonAssignment">
  <template v-slot:icon>
    <AssignmentIcon/>
  </template>
  <template v-slot:text>
    {{$t('buttons.assignment')}}
  </template>
</ButtonPrimary>
</template>

<script>
import ButtonPrimary from "./templates/ButtonPrimary";
import AssignmentIcon from "../icons/AssignmentIcon";
export default {
  name: "ButtonAssignment",
  components: {AssignmentIcon, ButtonPrimary}
}
</script>

<style scoped lang="scss">
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.v-btn--assignment {
  svg {
    .c {
      stroke: $white;
    }
  }

  &:hover {
    svg {
      .a, .b {
        fill: map-get($green, 'base');
        stroke: $white;
      }

      .c {
        stroke: map-get($green, 'base');
      }
    }
  }
}
</style>
